export default class Movie {
    constructor(scroll) {
        this.player = null;
        this.scroll = scroll;
        this.init();
    }

    init() {
        this.moviemodal = document.querySelector(".js-moviemodal");

        if (this.moviemodal !== null) {
            this.setup();
            this.eventBind();
        }
    }

    setup() {
        const tag = document.createElement("script");
        tag.src = "https://www.youtube.com/iframe_api";
        tag.async = true;
        const firstScriptTag = document.getElementsByTagName("script")[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

        window.onYouTubeIframeAPIReady = () => {
            this.player = new YT.Player("player", {
                height: "360",
                width: "640",
            });
        };
    }

    eventBind() {
        const closebuttons = document.querySelectorAll(".js-modal_close");
        const openbuttons = document.querySelectorAll(".js-modal_open");

        closebuttons.forEach((el) => {
            el.addEventListener("click", () => {
                this.moviemodal.classList.remove("-active");
                document.body.classList.remove("-lock");
                this.player.stopVideo();

                // Lenisを再開
                if (this.scroll && this.scroll.lenis) {
                    this.scroll.lenis.start();
                }
            });
        });

        openbuttons.forEach((el) => {
            el.addEventListener("click", () => {
                const videoID = el.getAttribute("data-videoID");
                this.moviemodal.classList.add("-active");
                document.body.classList.add("-lock");
                this.loadVideo(videoID);

                // Lenisを停止
                if (this.scroll && this.scroll.lenis) {
                    this.scroll.lenis.stop();
                }
            });
        });
    }

    loadVideo(id) {
        //デフォルトでautoplayされる。
        this.player.loadVideoById({ videoId: id });
    }
}
